import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SPECIES_SAVE } from "../../../../enums/ApiPaths";
import { icons } from "../../../../enums/PetIcons";
import { CRIMSON_RED } from "../../../../enums/Colors";
import usePrimaryColor from "../../../../hooks/usePrimaryColor";
import useSubmit from "../hooks/useSubmit";
import { SPECIES_MASTER } from "../../../../enums/QueryKeys";

export default function SpeciesForm() {
  const { t, i18n } = useTranslation();
  const methods = useForm();
  const color = usePrimaryColor();
  const banIcon = "fa-ban";
  const submittion = useSubmit(null, SPECIES_SAVE, SPECIES_MASTER);
  const currentLanguage = i18n.language;
  const [selectedIcon, setSelectedIcon] = useState(banIcon);

  async function handleSubmitSpecies(data) {
    const obj = parseSubmitData(data);
    await submittion.submitCallback(obj);
    methods.reset();
    setSelectedIcon(banIcon);
  }

  function parseSubmitData(data) {
    var obj = {
      ...data,
      icon: selectedIcon,
      translations: {
        [currentLanguage]: data?.title,
      },
    };
    if (selectedIcon === banIcon) {
      return {
        ...obj,
        icon: null,
      };
    }
    return obj;
  }

  function bgcolor(icon) {
    if (icon === banIcon && selectedIcon == banIcon) {
      return CRIMSON_RED;
    } else {
      return selectedIcon === icon ? color : "grayText";
    }
  }

  return (
    <Paper sx={{ p: 2, mb: 5 }}>
      <form onSubmit={methods.handleSubmit(handleSubmitSpecies)}>
        <Stack justifyContent={"center"} alignItems={"flex-start"} spacing={2}>
          <Controller
            name="title"
            defaultValue={""}
            control={methods.control}
            rules={{ required: t("CantBeEmpty") }}
            render={({ field }) => (
              <TextField
                {...field}
                size="small"
                variant="standard"
                label={t("AddSpecies")}
                fullWidth
                error={!!methods.formState.errors.title}
                helperText={
                  methods.formState.errors.title
                    ? methods.formState.errors.title.message
                    : ""
                }
              />
            )}
          />
          <Typography variant="h6">{t("ChooseIcon")}</Typography>
          <Grid container gap={1}>
            {icons.map((icon, index) => (
              <Grid
                item
                key={index}
                onClick={() => setSelectedIcon(icon.icon)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  height: 75,
                  width: 75,
                  backgroundColor: bgcolor(icon.icon),
                  boxShadow: selectedIcon === icon.icon ? 3 : 0,
                  borderRadius: 2,
                }}
              >
                <i
                  className={`fas ${icon.icon}`}
                  style={{
                    fontSize: 35,
                    color: "white",
                  }}
                />
              </Grid>
            ))}
          </Grid>
          <Box>
            <Button
              variant="contained"
              color="info"
              size="small"
              sx={{ width: "100%" }}
              type="submit"
              disabled={!selectedIcon} // Disable if no icon is selected
            >
              {t("Add")}
            </Button>
          </Box>
        </Stack>
      </form>
    </Paper>
  );
}
